<template src="./template.html" />
<script>
import { Promise } from 'q'
import Inputs from 'src/components/fields-generator/index.js'
import { firebase } from '@firebase/app'
import Moment from 'moment'
import { checkPermission, getPermission } from 'naf-acl'
import NumberUtilsLib from 'utils/NumberUtils'
export default {
  name: 'LandingPage',
  components: Inputs,
  props: {
    title: {
      type: String,
      default: () => ''
    },
    hideBackButton: {
      type: Boolean,
      default: false
    },
    hideBottom: {
      type: Boolean,
      default: false
    },
    queryConditions: {
      type: Object,
      default: () => undefined
    },
    baseData: {
      type: [Object, Array],
      default: () => undefined
    },
    backLink: {
      type: [String, Object],
      default: () => '/'
    },
    routeDetailName: {
      type: String,
      default: ''
    },
    headers: {
      type: Array,
      default: () => []
    },
    idFieldName: {
      type: String,
      default: ''
    },
    canQuery: {
      type: Boolean,
      default: true
    },
    canCreate: {
      type: Boolean,
      default: () => undefined
    },
    canCopy: {
      type: Boolean,
      default: () => undefined
    },
    canDelete: {
      type: [Boolean, Function],
      default: () => undefined
    },
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    useOneMeta: {
      type: Boolean,
      default: () => false
    },
    showPagination: {
      type: Boolean,
      default: () => false
    },
    masterData: {
      type: [Array, Object, Function],
      default: null
    },
    mapMasterDataFunc: {
      type: [Array, Object, Function],
      default: null
    }
  },
  data () {
    return {
      data: [],
      isLoading: true,
      confirmDeleteDialog: false,
      isCopying: false,
      isDeleting: false,
      selectedRow: {},
      rowIndex: 0,
      privateQueryCondition: this._.cloneDeep(this.queryConditions),
      res: [],
      privatePagination: this.tableConfig.pagination,
      fetchedPage: 1,
      cachingData: []
    }
  },
  async created() {
    this.$on('updateQueryConditions', (payload) => {
      this.privateQueryCondition = payload ? this._.cloneDeep(payload) : this._.cloneDeep(this.queryConditions)
    })
    this.$on('fetchData', this.fetchData)
    this.showLoading()
    this.isLoading = true
  },
  async mounted () {
    this.assignBaseData()
    await this.fetchData()
    this.hideLoading()
  },
  methods: {
    assignBaseData() {
      if(this.baseData) {
        this.data = this.baseData
        this.data.forEach((item, index) => item.position = index)
        this.cacheData(this.data)
      }
    },
    async fetchData () {
      let vm = this
      vm.isLoading = true
      if(vm.privateQueryCondition && vm.canQuery) {
        try {
          await vm.$query(vm.privateQueryCondition.ref, vm.privateQueryCondition.filter, vm.privateQueryCondition.order,
          vm.privateQueryCondition.limit, vm.privateQueryCondition.after, vm.privateQueryCondition.returnSnapshot).then(async res => {
            if(res.error) throw new Error(res.error.message)
            vm.data = Array.isArray(res.data) ? res.data : res[vm.privateQueryCondition.fieldName]
            vm.data.forEach((item, index) => item.position = index)
            vm.data = vm.mapOptions(vm.data)
            vm.res = res
            vm.cacheData(vm.data)
            if(vm.mapMasterDataFunc) {
              vm.data = await vm.mapMasterDataFunc(vm.data, vm.masterData)
            }
            vm.$emit('landing-pages-fetched', vm.data)
          }).catch(e => {
            console.log(e)
            vm.$q.notify({
              message: `${e}`,
              color: 'red',
              icon: 'error'
            })
          })
        } catch (error) {
          console.error(error)
          if(error.code === 'invalid-argument') {
            vm.$q.notify({
              message: `Điều kiện lọc không hỗ trợ`,
              color: 'red',
              icon: 'error'
            })
          }
        }
      }
      this.isLoading = false
    },
    cacheData (newData) {
      if(this.R.isEmpty(this.cachingData)) {
        this.cachingData = this.cachingData.concat(newData)
      }
    },
    routeDetail (id, data) {
      this.showLoading()
      this.$emit('edit-event', id, data)
      this.hideLoading()
    },
    async submitDelete () {
      let vm = this
      vm.showLoading()
      this.isLoading = true
      this.isDeleting = true
      let result = new Promise((resolve, reject) => this.$emit('delete-event', this.selectedRow, resolve, reject))
      try {
        await result.then(() => {
          vm.$q.notify({
            message: 'Đã xóa thành công',
            color: 'black',
            icon: 'check'
          })
          vm.fetchData()
        })
      } catch (error) {
        vm.$q.notify({
          message: error.toString(),
          color: 'red',
          icon: 'error'
        })
      }
      this.isLoading = false
      this.isDeleting = false
      vm.hideLoading()
    },
    showLoading () {
      if (this.$root.$children[0].$refs['top-loadding-bar']) this.$root.$children[0].$refs['top-loadding-bar'].start()
    },
    hideLoading () {
      let vm = this
      vm.$nextTick(() => {
        if (vm.$root.$children[0].$refs['top-loadding-bar']) vm.$root.$children[0].$refs['top-loadding-bar'].stop()
      })
    },
    addButtonClick () {
      this.$emit('add-button-click')
    },
    copyButtonClick (id) {
      this.isCopying = true
      this.showLoading()
      this.$emit('copy-event', id)
      this.hideLoading()
      this.isCopying = false
    },
    // eslint-disable-next-line no-unused-vars
    formatString (string, $this, row, col) {
      // eslint-disable-next-line no-unused-vars
      let Timestamp = firebase.firestore.Timestamp
      // eslint-disable-next-line no-unused-vars
      let moment = Moment
      // eslint-disable-next-line no-unused-vars
      let NumberUtils = NumberUtilsLib
      // eslint-disable-next-line no-eval
      return eval(string)
    },
    checkDelete(item) {
      if(!this.R.isNil(this.canDelete) && typeof this.canDelete === 'boolean') return this.canDelete
      if(this.canDelete instanceof Function) return this.canDelete(item)
      let perm = this.useOneMeta ? this.getPermission(this.R.path(['permission'], this.res.metaData)) : this.getPermission(this.R.path(['metaData', 'permission'], item))
      return perm.indexOf('write') !== -1 || perm.indexOf('delete') !== -1
    },
    checkPermission,
    getPermission,
    sortMethod(rows, sortBy, desc) {
      let rowsCopy = this.R.clone(rows)
      let vm = this
      let cols = vm.headers
      let found = vm._.find(cols, item => item.name === sortBy)
      let sortResult = rowsCopy.sort((a, b) => {
        let x = desc ? b[sortBy] : a[sortBy]
        let y = desc ? a[sortBy] : b[sortBy]
        if(found && found.sort) {
          return found.sort(x, y)
        }
        if(typeof x === 'string' && typeof y === 'string') {
          return x.localeCompare(y)
        }
        return x > y ? 1 : x < y ? -1 : 0
      })
      sortResult.forEach((element, index) => {
        element.position = index
      })
      return sortResult
    },
    scrollToTop() {
      try {
        this.$refs['scrollToTop'].$el.click()
      // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
    resetPaginationState() {
      this.cachingData = []
      this.fetchedPage = 1
      this.privatePagination.rowsNumber = this.tableConfig.pagination.rowsNumber
    },
    fetchSortBy(sortBy, desc) {
      if(sortBy !== this.privateQueryCondition.order[0] || (desc ? 'desc' : 'asc') !== this.privateQueryCondition.order[1]) {
        this.privateQueryCondition.after = null
        this.privateQueryCondition.order = sortBy ? [sortBy, desc ? 'desc' : 'asc'] : this.R.clone(this.queryConditions.order)
        this.resetPaginationState()
        return this.fetchData()
      }
      return true
    },
    fetchLimit() {
      this.resetPaginationState()
      return this.fetchData()
    },
    async handlePagination(props) {
      this.scrollToTop()
      if(!props.pagination.sortBy) {
        props.pagination.sortBy = null
        await this.fetchSortBy(this.queryConditions.order[0], props.pagination.descending)
      } else {
        await this.fetchSortBy(props.pagination.sortBy, props.pagination.descending)
      }
      if(props.pagination.rowsPerPage !== this.privateQueryCondition.limit) {
        this.privateQueryCondition.limit = props.pagination.rowsPerPage
        this.fetchLimit()
      }
      if(props.pagination.page > this.fetchedPage) {
        let oldRecords = this._.cloneDeep(this.cachingData)
        this.privateQueryCondition.after = this.res.docsSnapshot.docs[this.res.docsSnapshot.size - 1]
        await this.fetchData()
        if(this.data.length > 0 && props.pagination.page > this.fetchedPage) {
          oldRecords = oldRecords.concat(this.data)
          this.cachingData = oldRecords
          this.fetchedPage = props.pagination.page
          this.privatePagination.rowsNumber+= oldRecords.length
        } else {
          this.privatePagination.rowsNumber = oldRecords.length
          this.data = this.cachingData.slice((props.pagination.page - 1) * props.pagination.rowsPerPage, props.pagination.page * props.pagination.rowsPerPage)
        }
      } else {
        this.data = this.cachingData.slice((props.pagination.page - 1) * props.pagination.rowsPerPage, props.pagination.page * props.pagination.rowsPerPage)
      }
      this.privatePagination.rowsPerPage = props.pagination.rowsPerPage
      this.privatePagination.page = props.pagination.page
      this.privatePagination.sortBy = props.pagination.sortBy
      this.privatePagination.descending = props.pagination.descending
    },
    uniqBy(a, key) {
      let seen = new Set();
      return a.filter(item => {
        let k = key ? this._.get(item, key) : k;
        return seen.has(k) ? false : seen.add(k);
      });
    },
    mapOptions(data) {
      let listMap = {}
      for(let col of this.headers) {
        if(col.mapOptions) {
          let keyBy = this._.keyBy(col.mapOptions.options, col.mapOptions.key)
          listMap[col.field] = keyBy
        }
      }
      let listKeyListMap = Object.keys(listMap)
      return listKeyListMap.length > 0 ? data.map(item => {
        listKeyListMap.forEach(key => {
          if(typeof item[key] === 'string') {
            item[key] = listMap[key][item]
          }
          if(Array.isArray(item[key])) {
            item[key] = item[key].map(subItem => listMap[key][subItem])
          }
        })
        return item
      }) : data
    }
  },
  watch: {
    queryConditions: {
      handler: function(newValue) {
        this.privateQueryConditions = this._.cloneDeep(newValue)
      },
      deep: true
    },
    baseData: {
      handler: function(newValue) {
        if(newValue) {
          this.assignBaseData()
        }
      }
    }
  }
}
</script>